import { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormCardLayout } from '@main/components';
import Button from '@mui/material/Button';
import { showMessage } from 'app/store/core/messageSlice';
import { useRequest } from '@main/hooks';
import {
  createApiSubDomain,
  createApiSubDomainSSL,
  createMainDomainSSL,
  createNotifySubDomain,
  createNotifySubDomainSSL,
  createTerminalsSubDomain,
  createTerminalsSubDomainSSL,
  // installNotifyNodejs,
} from 'src/app/api/setup';
import { delayFunction } from 'src/app/utils/timer';
import { useSimpleAlert } from '@main/hooks/useSimpleAlert';
import { arraysContainSameValues } from 'src/app/utils/conversors';
import { Divider, TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { regexEmail } from 'src/app/utils/validations';
import * as yup from 'yup';
import { ProgressStep } from '../Components';
import { StepperContext } from '../Context/SetupContext';
import { checkpointsPlesk, getCompletedCheckpoints } from '../Checkpoints/checkpoints';

const progressEnum = {
  waiting: 'WAITING',
  loading: 'LOADING',
  success: 'SUCCESS',
  error: 'ERROR',
};

const pleskSchema = yup.object().shape({
  email: yup.string().matches(regexEmail, 'Debes ingresar un correo válido'),
});

const defaultValues = {
  email: 'admin@webdecero.com',
};

export const Plesk = ({ onSuccess = () => {} }) => {
  const Dispatch = useDispatch();
  const openAlert = useSimpleAlert();
  const { addLogs, companyId, companyEmail, currentCheckpoint } = useContext(StepperContext);
  const [completedSteps, setCompletedSteps] = useState([checkpointsPlesk[0]]);
  const [disableButton, setDisableButton] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  // ----- Inicializacion de validadores de formulario
  const { control, formState, handleSubmit, setValue } = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(pleskSchema),
  });
  const { isValid, errors } = formState;

  // -------- Obteniendo checkpoints
  const handleUpdateSteps = (incomingStep) => {
    const stepIsThere = completedSteps.includes(incomingStep);
    if (stepIsThere) return;
    setCompletedSteps((current) => [...current, incomingStep]);
  };

  useEffect(() => {
    if (currentCheckpoint === undefined || currentCheckpoint === null) return;
    const isThere = checkpointsPlesk.includes(currentCheckpoint);
    if (!isThere) return;
    console.log(currentCheckpoint);
    const checkpointsList = getCompletedCheckpoints(currentCheckpoint);
    if (checkpointsList !== undefined) {
      console.log(checkpointsList);
      setCompletedSteps(checkpointsList);
    }
  }, [currentCheckpoint]);

  useEffect(() => {
    console.log('completed steps', completedSteps);
    if (completedSteps === undefined) return;
    console.log('has changed completedSteps');
    const isStepsComplete = arraysContainSameValues(completedSteps, checkpointsPlesk);
    console.log('Esta completo? ', isStepsComplete);
    setIsCompleted(isStepsComplete);
  }, [completedSteps]);

  useEffect(() => {
    if (isCompleted === undefined) return;
    onSuccess(isCompleted);
  }, [isCompleted]);

  useEffect(() => {
    return () => {
      setCompletedSteps([]);
    };
  }, []);

  // -------- Definicion de requests
  const {
    makeRequest: tryManagerSSL,
    isLoading: isLoadingManagerSSL,
    status: statusManagerSSL,
    logger: loggerManagerSSL,
  } = useRequest(createMainDomainSSL);

  const {
    makeRequest: trySdApi,
    isLoading: isLoadingSdApi,
    status: statusSdApi,
    logger: loggerSdApi,
  } = useRequest(createApiSubDomain);

  const {
    makeRequest: trySdApiSSL,
    isLoading: isLoadingSdApiSSL,
    status: statusSdApiSSL,
    logger: loggerSdApiSSL,
  } = useRequest(createApiSubDomainSSL);

  const {
    makeRequest: trySdNotify,
    isLoading: isLoadingSdNotify,
    status: statusSdNotify,
    logger: loggerSdNotify,
  } = useRequest(createNotifySubDomain);

  const {
    makeRequest: trySdNotifySSL,
    isLoading: isLoadingSdNotifySSL,
    status: statusSdNotifySSL,
    logger: loggerSdNotifySSL,
  } = useRequest(createNotifySubDomainSSL);

  const {
    makeRequest: trySdTerminals,
    isLoading: isLoadingSdTerminals,
    status: statusSdTerminals,
    logger: loggerSdTerminals,
  } = useRequest(createTerminalsSubDomain);

  const {
    makeRequest: trySdTerminalsSSL,
    isLoading: isLoadingSdTerminalsSSL,
    status: statusSdTerminalsSSL,
    logger: loggerSdTerminalsSSL,
  } = useRequest(createTerminalsSubDomainSSL);

  /*   const {
      makeRequest: tryInstallNotifyNode,
      isLoading: isLoadingInstallNotifyNode,
      status: statusInstallNotifyNode,
      logger: loggerInstallNotifyNode,
    } = useRequest(installNotifyNodejs); */

  useEffect(() => {
    if (loggerManagerSSL === undefined) return;
    addLogs(loggerManagerSSL);
  }, [loggerManagerSSL]);

  useEffect(() => {
    if (loggerSdApi === undefined) return;
    addLogs(loggerSdApi);
  }, [loggerSdApi]);

  useEffect(() => {
    if (loggerSdApiSSL === undefined) return;
    addLogs(loggerSdApiSSL);
  }, [loggerSdApiSSL]);

  useEffect(() => {
    if (loggerSdNotify === undefined) return;
    addLogs(loggerSdNotify);
  }, [loggerSdNotify]);

  useEffect(() => {
    if (loggerSdNotifySSL === undefined) return;
    addLogs(loggerSdNotifySSL);
  }, [loggerSdNotifySSL]);

  useEffect(() => {
    if (loggerSdTerminals === undefined) return;
    addLogs(loggerSdTerminals);
  }, [loggerSdTerminals]);

  useEffect(() => {
    if (loggerSdTerminalsSSL === undefined) return;
    addLogs(loggerSdTerminalsSSL);
  }, [loggerSdTerminalsSSL]);

  /*   useEffect(() => {
      if (loggerInstallNotifyNode === undefined) return;
      addLogs(loggerInstallNotifyNode);
    }, [loggerInstallNotifyNode]); */

  const tryStepsWizard = async (currentForm) => {
    setDisableButton(true);
    if (companyId === undefined) {
      Dispatch(
        showMessage({
          message: 'No se encontro el ID de compania',
        })
      );
      setDisableButton(false);
      return;
    }
    try {
      const formData = {
        email: currentForm.email || defaultValues.email,
      };

      // --- Domain Manager (Install SSL Domain)
      const step2ok = await delayFunction(
        completedSteps.includes(checkpointsPlesk[1]),
        tryManagerSSL,
        companyId,
        formData
      );
      if (!step2ok) return;
      handleUpdateSteps(checkpointsPlesk[1]);
      console.log('Step 2 okii');

      // ---- Subdomain API
      const step3ok = await delayFunction(
        completedSteps.includes(checkpointsPlesk[2]),
        trySdApi,
        companyId
      );
      if (!step3ok) return;
      handleUpdateSteps(checkpointsPlesk[2]);
      console.log('Step 3 okii');

      // ---- Subdomain API SSL
      const step4ok = await delayFunction(
        completedSteps.includes(checkpointsPlesk[3]),
        trySdApiSSL,
        companyId,
        formData
      );
      if (!step4ok) return;
      handleUpdateSteps(checkpointsPlesk[3]);
      console.log('Step 4 okii');

      // ----- Subdomain Notify
      const step5ok = await delayFunction(
        completedSteps.includes(checkpointsPlesk[4]),
        trySdNotify,
        companyId
      );
      if (!step5ok) return;
      handleUpdateSteps(checkpointsPlesk[4]);
      console.log('Step 5 okii');

      // ---- Subdomain Notify SSL
      const step6ok = await delayFunction(
        completedSteps.includes(checkpointsPlesk[5]),
        trySdNotifySSL,
        companyId,
        formData
      );
      if (!step6ok) return;
      handleUpdateSteps(checkpointsPlesk[5]);
      console.log('Step 6 okii');

      // ---- Subdomain Terminals
      const step7ok = await delayFunction(
        completedSteps.includes(checkpointsPlesk[6]),
        trySdTerminals,
        companyId
      );
      if (!step7ok) return;
      handleUpdateSteps(checkpointsPlesk[6]);
      console.log('Step 7 okii');

      // ---- Subdomain Terminals SSL
      const step8ok = await delayFunction(
        completedSteps.includes(checkpointsPlesk[7]),
        trySdTerminalsSSL,
        companyId,
        formData
      );
      if (!step8ok) return;
      handleUpdateSteps(checkpointsPlesk[7]);
      console.log('Step 8 okii');

      // ---- Subdomain Notify SSL
      /*  const step7ok = await delayFunction(
         completedSteps.includes(checkpointsPlesk[6]),
         tryInstallNotifyNode,
         companyId,
         useEmail ? { email: companyEmail } : null
       );
       if (step7ok) {
         handleUpdateSteps(checkpointsPlesk[6]);
         console.log('Step 7 okii');
         return;
       }
       // ---- Reintent Subdomain Notify SSL
       const reintentStep7ok = await delayFunction(
         completedSteps.includes(checkpointsPlesk[6]),
         tryInstallNotifyNode,
         companyId,
         useEmail ? { email: companyEmail } : null
       );
       if (!reintentStep7ok) return;
       handleUpdateSteps(checkpointsPlesk[6]);
       console.log('Step 7 okii'); */

      // ------
    } catch (error) {
      console.log(error);
    } finally {
      setDisableButton(false);
    }
  };

  const handleBypassStep = (stepName) => {
    if (typeof stepName !== 'string' || stepName === undefined) return;
    openAlert({
      title: 'Atencion',
      description: 'Esta seguro que desea omitir este paso?',
    }).then((userResponseOk) => {
      if (!userResponseOk) return;
      handleUpdateSteps(stepName);
      Dispatch(
        showMessage({
          message: `El paso ${stepName} ha sido omitido`,
        })
      );
    });
  };

  useEffect(() => {
    console.log(companyId);
  }, [companyId]);

  useEffect(() => {
    onSuccess(false);
  }, []);

  const handleManualRetry = (reqToRetry = () => new Promise(), ...args) => {
    reqToRetry(...args)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <FormCardLayout.FullColum>
        <form
          name="laravelForm"
          className="flex flex-col justify-center px-12 py-4 w-full"
          autoComplete="off"
        >
          <div className="flex items-center justify-between gap-32">
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Correo electrónico para generación de SSL"
                  type="email"
                  error={!!errors.email}
                  helperText={errors?.email?.message}
                  variant="outlined"
                  required
                  fullWidth
                />
              )}
            />
            <Button
              aria-label="Comenzar"
              onClick={handleSubmit(tryStepsWizard)}
              variant="contained"
              className="w-[120px]"
              color="primary"
              disabled={!isValid || disableButton || isCompleted}
            >
              Comenzar
            </Button>
          </div>
        </form>
      </FormCardLayout.FullColum>
      <FormCardLayout.FullColum>
        <Divider variant="middle" />
      </FormCardLayout.FullColum>
      <FormCardLayout.FullColum>
        <div className="px-32 flex flex-col w-full justify-start items-start">
          <ProgressStep
            disableOptions
            status={progressEnum.success}
            stepName="Ambientando dominio"
          />
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsPlesk[1])}
            status={completedSteps.includes(checkpointsPlesk[1]) ? 'SUCCESS' : statusManagerSSL}
            isLoading={isLoadingManagerSSL}
            stepName="Instalando Certificado SSL a Dominio"
            disableOptions={completedSteps.includes(checkpointsPlesk[1])}
          />
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsPlesk[2])}
            status={completedSteps.includes(checkpointsPlesk[2]) ? 'SUCCESS' : statusSdApi}
            isLoading={isLoadingSdApi}
            stepName="Ambientando Subdominio API"
            disableOptions={completedSteps.includes(checkpointsPlesk[2])}
          />
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsPlesk[3])}
            status={completedSteps.includes(checkpointsPlesk[3]) ? 'SUCCESS' : statusSdApiSSL}
            isLoading={isLoadingSdApiSSL}
            stepName="Instalando Certficado SSL a Subdominio API"
            disableOptions={completedSteps.includes(checkpointsPlesk[3])}
          />
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsPlesk[4])}
            status={completedSteps.includes(checkpointsPlesk[4]) ? 'SUCCESS' : statusSdNotify}
            isLoading={isLoadingSdNotify}
            stepName="Ambientando Subdominio Notify"
            disableOptions={completedSteps.includes(checkpointsPlesk[4])}
          />
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsPlesk[5])}
            status={completedSteps.includes(checkpointsPlesk[5]) ? 'SUCCESS' : statusSdNotifySSL}
            isLoading={isLoadingSdNotifySSL}
            stepName="Instalando Certificado SSL a Subdominio Notify"
            disableOptions={completedSteps.includes(checkpointsPlesk[5])}
          />
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsPlesk[6])}
            status={completedSteps.includes(checkpointsPlesk[6]) ? 'SUCCESS' : statusSdTerminals}
            isLoading={isLoadingSdTerminals}
            stepName="Ambientando Subdominio Terminals"
            disableOptions={completedSteps.includes(checkpointsPlesk[6])}
          />
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsPlesk[7])}
            status={completedSteps.includes(checkpointsPlesk[7]) ? 'SUCCESS' : statusSdTerminalsSSL}
            isLoading={isLoadingSdTerminalsSSL}
            stepName="Instalando Certificado SSL a Subdominio Terminals"
            disableOptions={completedSteps.includes(checkpointsPlesk[7])}
          />
          {/* <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsPlesk[6])}
            status={
              completedSteps.includes(checkpointsPlesk[6]) ? 'SUCCESS' : statusInstallNotifyNode
            }
            isLoading={isLoadingInstallNotifyNode}
            stepName="Instalando NodeJS para Notify"
            disableOptions={completedSteps.includes(checkpointsPlesk[6])}
          /> */}
        </div>
      </FormCardLayout.FullColum>
    </>
  );
};
